import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const EditSuggestedCustomerPersonaPopup = loadAsyncComponent(
  () => import('./Container'),
  'popup'
);
